const DEFAULT_CHAR_LIMIT = 50;

const truncateText = (text = '', charLimit = DEFAULT_CHAR_LIMIT, withTooltip = true) => {
  if (!text) return { text: '', tooltipText: null };

  const isTruncated = text.length > charLimit;
  return withTooltip && isTruncated
    ? { text: `${text.substring(0, charLimit)}...`, tooltipText: text }
    : { text: isTruncated ? `${text.substring(0, charLimit)}...` : text, tooltipText: null };
};

export default truncateText;
